import { Examples } from '@/types';

export const ExampleReferencesAccordionRoutes =
  process.env.NODE_ENV !== 'production'
    ? [
      {
        ...Examples.ExampleReferencesAccordion,
        components: {
          default: () => import(/* webpackChunkName: "ExampleReferencesAccordion" */
            '@/views/examples/ExampleReferencesAccordion.vue')
        }
      }
    ]
    : [];